import React from "react";
import { MapPin } from "react-feather";

import BranchesData from "./BranchesData.json";

const Branches = () => {
  return (
    <div className="main-container">
      <h1 className="title">Our Branches</h1>
      {BranchesData.map((branchesDetail, index) => {
        return (
          <div id="detailsContainer">
            <div className="name">{branchesDetail.name}</div>
            <div
              className="address"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <MapPin style={{ color: "var(--primary)", height: "10px" }} />
              {branchesDetail.address}
            </div>
            <div className="inner-details">
              <div className="detail">
                <div className="label">Branch Manager</div>
                <div className="content">{branchesDetail.branchManager}</div>
              </div>
              <div className="detail">
                <div className="label">Email Address</div>
                <div className="content">{branchesDetail.email}</div>
              </div>
              <div className="detail">
                <div className="label">Contact Number</div>
                <div className="content">{branchesDetail.contactNo}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Branches;
